/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
export type ISourcedCarrierRateInfoFragment = { __typename?: 'SourcedCarrierRate' } & Pick<
  Types.ISourcedCarrierRate,
  | 'id'
  | 'canDoWeekends'
  | 'confirmed'
  | 'createdAt'
  | 'maxCapacity'
  | 'minCapacity'
  | 'rateSource'
  | 'updatedAt'
> & {
    carrierApplication: { __typename?: 'CarrierApplication' } & Pick<
      Types.ICarrierApplication,
      'id' | 'name' | 'dotNumber' | 'mcNumber' | 'fmcsaRating' | 'isTrusted' | 'state'
    >
    createdBy?: Types.Maybe<{ __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>>
    latestLaneAgreement?: Types.Maybe<
      { __typename?: 'AttachedDocument' } & Pick<Types.IAttachedDocument, 'id' | 'createdAt'>
    >
    rate: { __typename?: 'Rate' } & Pick<Types.IRate, 'id' | 'amount' | 'rateTypeKey'>
    updatedBy?: Types.Maybe<{ __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'>>
  }

export const SourcedCarrierRateInfoFragmentDoc = gql`
  fragment SourcedCarrierRateInfo on SourcedCarrierRate {
    id
    canDoWeekends
    carrierApplication {
      id
      name
      dotNumber
      mcNumber
      fmcsaRating
      isTrusted
      state
    }
    confirmed
    createdAt
    createdBy {
      id
      fullName
    }
    latestLaneAgreement {
      id
      createdAt
    }
    maxCapacity
    minCapacity
    rate {
      id
      amount
      rateTypeKey
    }
    rateSource
    updatedAt
    updatedBy {
      id
      fullName
    }
  }
`
